import React, { useState } from "react";
import { Layout, Typography, Row, Col, Form, Input, Card, Select } from "antd";
import { useNavigate } from "react-router-dom";
import CustomButton from "../../../../components/custom/CustomButton";
const { Text } = Typography;

const BranchTypesForm = ({
  allowedPaymentTypeData,
  session,
  setIsLoading,
  cnt,
  apiConfig,
  BOM,
}) => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [allowedStatus, setAllowedStatus] = useState(0);

  const totalOptions = allowedPaymentTypeData?.length || 0;

  const onCancel = () => {
    navigate("/sya0300", { replace: false });
  };

  const onValuesChange = (_, allValues) => {
    const selected = allValues.allowedPaymentTypes || [];

    if (selected.length === 0) {
      setAllowedStatus(0); // none
    } else if (selected.length === totalOptions) {
      setAllowedStatus(1); // all
    } else {
      setAllowedStatus(2); // partial
    }
  };

  const handleSubmit = (values) => {
    const payload = {
      name: values.name,
      paymentTypes: values.allowedPaymentTypes, // array of IDs
      allowedPaymentTypes: allowedStatus, // derived from selection
    };

    const body = {
      ...payload,
      method: "POST",
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, apiConfig.Officetype, (err, res) => {
      setIsLoading(false);
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, "Branch Type Created Successfully");

        navigate("/sya0300", { replace: false });
      }
    });
  };

  return (
    <Form
      form={form}
      layout="vertical"
      style={{ paddingTop: 20 }}
      onFinish={handleSubmit}
      onValuesChange={onValuesChange}
    >
      <Card
        style={{
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
        }}
        title="Create Branch Type"
      >
        <Card
          style={{
            marginBottom: "2%",
            boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
          }}
        >
          <Row gutter={16} style={{ justifyContent: "space-between" }}>
            <Col span={12}>
              <Form.Item
                name="name"
                label={<Text strong>Name</Text>}
                rules={[{ required: true, message: "Required Field" }]}
              >
                <Input />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item
                name="allowedPaymentTypes"
                label={<Text strong>Allowed Payment Types</Text>}
                
              >
                <Select
                  mode="multiple"
                  showSearch
                  placeholder="Select Option(s)"
                  options={allowedPaymentTypeData}
                />
              </Form.Item>
            </Col>
          </Row>
        </Card>
        <Form.Item>
          <Row>
            <CustomButton
              content="Submit"
              htmlType="submit"
              style={{
                width: "10%",
                marginLeft: "auto",
                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
              }}
              backgroundColor="#92428B"
              colorText="white"
              hoverBackground="#AD4EA7"
            />
            <CustomButton
              content="Cancel"
              style={{
                width: "10%",
                marginLeft: "1%",
                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
              }}
              backgroundColor="#fff"
              colorText="black"
              hoverBackground="#F5F5F5"
              onClick={onCancel}
            />
          </Row>
        </Form.Item>
      </Card>
    </Form>
  );
};

export default BranchTypesForm;
